export default "__VITE_ASSET__CATCqCXD__"